import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import fr from './fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['htmlTag'],
      htmlTag: typeof document !== 'undefined' ? document.documentElement : undefined,
      caches: [], // 🧼 Disable storage cache that might override detection
    },
  })
  .then(() => {
    // 🚨 Force the language switch manually
    const detectedLang = document.documentElement.lang || 'en';
    // console.debug('[i18n] Forcing language to:', detectedLang);
    i18n.changeLanguage(detectedLang);
  });

// i18n.on('languageChanged', (lng) => {
//   console.debug('[i18n] Detected language:', lng);
// });

// console.debug('HTML lang attribute:', document.documentElement.lang);

export default i18n;
